class StatusCodeHelper {
  checkStatusCodeSuccess(statusCode: number) {
    return statusCode >= 200 && statusCode <= 299;
  }
}

export const statusCodeHelper = new StatusCodeHelper();
